import { useState } from "react";
import menuSections from "../constants/menu.json";
import { SECTION_IDS } from "../constants/sections";
import { MENU_STRINGS } from "../constants/strings";

function MenuSection() {
  const [activeMenuCategory, setActiveMenuCategory] = useState(
    menuSections[0].title
  );

  const activeMenuSection =
    menuSections.find((section) => section.title === activeMenuCategory) ||
    menuSections[0];

  return (
    <section id={SECTION_IDS.menu} className="section menu-section">
      <div className="section-inner">
        <div className="section-heading">
          <p className="eyebrow">{MENU_STRINGS.eyebrow}</p>
          <h2>{MENU_STRINGS.heading}</h2>
          <p>{MENU_STRINGS.paragraph}</p>
        </div>

        <div
          className="menu-tabs"
          role="tablist"
          aria-label={MENU_STRINGS.tabsAriaLabel}
        >
          {menuSections.map((section) => (
            <button
              key={section.title}
              type="button"
              role="tab"
              aria-selected={activeMenuCategory === section.title}
              className={`menu-tab${
                activeMenuCategory === section.title ? " active" : ""
              }`}
              onClick={() => setActiveMenuCategory(section.title)}
            >
              {section.title}
            </button>
          ))}
        </div>

        <div className="menu-items-grid">
          {activeMenuSection.items.map((item) => (
            <article className="menu-item-card" key={item.name}>
              <img
                src={item.image || "/menu-placeholder.png"}
                alt={item.image ? item.name : MENU_STRINGS.placeholderAlt}
                className={item.image ? "" : "menu-item-placeholder"}
              />
              <h4>{item.name}</h4>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}

export default MenuSection;
